import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  token,
  profile,
  alert,
  params,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import LOGO from "../assets/images/logo-w.png";

import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: global.game[Number(params("id"))] || null,
      id: "",
      select_package: "",
      select_payment: "",
      id_game: "",
    };
  }
  async componentDidMount() {
    loading(false);
  }

  Payment = async () => {
    const { data, id_game, select_package, select_payment } = this.state;
    if (profile) {
      if (id_game === "") {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอก id game");
        return;
      }
      if (select_package === "") {
        alert("", "warning", "แจ้งเตือน", "กรุณาเลือกแพ็คเกจ");
        return;
      }
      if (select_payment === "") {
        alert("", "warning", "แจ้งเตือน", "กรุณาเลือกการชำระเงิน");
        return;
      }
      await fetch(
        `${
          "https://swiftgamepay-default-rtdb.asia-southeast1.firebasedatabase.app/"
        }payment_game/${new Date().getTime()}.json`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            package: data?.package[select_package],
            payment: global.payment[select_payment]?.name,
            fee: global.payment[select_payment]?.fee,
            price:
              Number(
                data?.package[select_package]?.new_price.replaceAll(",", "")
              ) +
                Number(
                  data?.package[select_package]?.new_price.replaceAll(",", "")
                ) *
                  global.payment[select_payment]?.fee || 0,
          }),
        }
      );
      await alert("login", "success", "สำเร็จ", "QR code การชำระเงิน ถูกส่งไปทางอีเมลที่ท่านได้ลงทะเบียนไว้ กรุณาชำระเงินภายใน 30 นาที");
      window.location.href = "/"
    } else {
      alert("", "warning", "แจ้งเตือน", "กรุณาเข้าสู่ระบบก่อนทำรายการ");
      return;
    }
  };
  render() {
    const { data, id, select_package, select_payment, id_game } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-dark position-relative">
        <Navbar />
        <div className="container mx-auto my-5">
          <div className="row">
            <div className="col-12 col-lg-8">
              <div className="mx-auto d-flex bg-white rounded-4 mb-3 position-relative">
                <img
                  src={require(`../assets/images/game/image-${String(
                    Number(params("id")) + 2
                  ).padStart(2, "0")}.png`)}
                  alt=""
                  className="wpx-300 hpx-300 me-4 rounded-4"
                />
                <div
                  className="wpx-50 hpx-300 position-absolute"
                  style={{
                    left: 250,
                    background: "#000000ff",
                    background:
                      "linear-gradient(90deg,rgba(0, 0, 0, 0) 0%, rgba(255, 255, 255, 1) 100%)",
                  }}
                ></div>
                <div className="px-3 py-2">
                  <h1 className="fw-bold mb-4">{data?.name || ""}</h1>
                  <div className="mb-2 d-flex flex-column">
                    {data?.cont
                      ?.trim()
                      ?.split(/\s*(?=\d+\.\s)/)
                      .filter((e) => e.trim() !== "")
                      .map((e, i) => (
                        <div key={i} className="w-100">
                          {e.trim()}
                        </div>
                      )) || ""}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <input
                    type="text"
                    className="form-control w-100 mb-3"
                    placeholder="ID game"
                    onChange={(e) => {
                      this.setState({ id_game: e.target.value });
                    }}
                    value={id_game}
                  />
                </div>
                {data?.package?.map((item, index) => (
                  <div className="col-12 col-sm-6 col-md-4 col-xl-3 mb-3">
                    <div
                      className={`mx-auto ${
                        select_package === index
                          ? "bg-primary-light border-0 border-info"
                          : "bg-white border-0"
                      } rounded-4 overflow-hidden pointer product`}
                      onClick={() => {
                        this.setState({ select_package: index });
                      }}
                    >
                      <div className="w-100 hpx-90 p-2">
                        <h6
                          className="fw-bold w-100 overflow-hidden mb-0 text-nowrap mb-2"
                          style={{ textOverflow: "ellipsis" }}
                        >
                          {item.name || ""}
                        </h6>
                          <h5
                            className="text-info fw-bold"
                            style={{ textOverflow: "ellipsis" }}
                          >
                            ฿ {item.new_price || "-"}
                          </h5>
                          <div style={{marginTop:-12}}>
                          <s
                            className="text-secondary"
                            style={{ textOverflow: "ellipsis" }}
                          >
                            <small>฿ {item.old_price || "-"}</small>
                          </s>
                          </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="p-3 mx-auto bg-white rounded-4">
                <h5 className="fw-bold mb-4">ช่องทางการชำระเงิน</h5>
                <div className="row mb-3">
                  {global.payment.map((item, index) => (
                    <div className="col-12 col-xl-6 mb-2 px-1">
                      <div
                        className={`mx-auto ${
                          select_payment === index
                            ? "bg-primary-light border-1 border-info"
                            : "bg-white border-1 border-secondary"
                        } rounded-4 overflow-hidden pointer product`}
                        onClick={() => {
                          this.setState({ select_payment: index });
                        }}
                      >
                        <div className="w-100 p-1 d-flex align-items-center">
                          <img
                            src={item?.image}
                            alt=""
                            className="wpx-40 hpx-40 me-3 rounded-4"
                          />
                          <h6
                            className="fw-bold w-100 overflow-hidden mb-0 text-nowrap"
                            style={{ textOverflow: "ellipsis" }}
                          >
                            {item.name || ""}
                          </h6>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="d-flex justify-content-between">
                  <span>ราคาสินค้า</span>
                  <span>
                    {(
                      Number(
                        data?.package[select_package]?.new_price.replaceAll(
                          ",",
                          ""
                        )
                      ) || 0
                    )?.toFixed(2)}
                  </span>
                </div>
                <hr />
                <div className="d-flex justify-content-between">
                  <span>ช่องทางการชำระเงิน</span>
                  <span>{global.payment[select_payment]?.name || "-"}</span>
                </div>
                <hr />
                <div className="d-flex justify-content-between">
                  <span>ค่าบริการ</span>
                  <span>
                    {(
                      Number(
                        data?.package[select_package]?.new_price.replaceAll(
                          ",",
                          ""
                        )
                      ) * global.payment[select_payment]?.fee || 0
                    )?.toFixed(2)}
                  </span>
                </div>
                <hr />
                <div className="d-flex justify-content-between mb-3">
                  <span>จำนวนเงินที่ชำระ</span>
                  <span>
                    {(
                      Number(
                        data?.package[select_package]?.new_price.replaceAll(
                          ",",
                          ""
                        )
                      ) +
                        Number(
                          data?.package[select_package]?.new_price.replaceAll(
                            ",",
                            ""
                          )
                        ) *
                          global.payment[select_payment]?.fee || 0
                    )?.toFixed(2)}
                  </span>
                </div>
                <button
                  className="btn btn-primary w-100"
                  onClick={() => {
                    this.Payment();
                  }}
                >
                  ชำระเงิน
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="w-100 align-content-center text-dark pb-5">
          <div className="container mx-auto">
        <div className="w-100 mb-5 p-3 border-1 rounded-4 bg-light">
            <h5>เงื่อนไขการคืนเงิน (Refund Policy) - SwiftGamePay</h5>
            <b>1. ขอบเขตการคืนเงิน</b><br/>
            <p>SwiftGamePay ให้สิทธิ์ในการขอคืนเงินสำหรับธุรกรรมที่เข้าเงื่อนไข ดังนี้</p><br/>
            <ul>
              <li>โปรโมชั่นไม่เป็นไปตามที่โฆษณา เช่น ของรางวัล, เครดิต, หรือสิทธิประโยชน์ไม่ตรงตามที่ระบุ</li>
              <li>ปัญหาทางเทคนิค ที่เกิดจากระบบของ SwiftGamePay ซึ่งทำให้การชำระเงินไม่สำเร็จ หรือเกิดการหักเงินซ้ำ</li>
              <li>ตามข้อบังคับทางกฎหมาย หรือคำสั่งจากหน่วยงานที่มีอำนาจกำกับดูแล</li>
            </ul>
              <b> 2. ระยะเวลาการขอคืนเงิน</b><br/>
              <ul>
                <li>ผู้ใช้ต้องยื่นคำขอคืนเงิน ภายใน 7 วัน สำหรับธุรกรรมทั่วไป</li>
                <li>สำหรับกรณีตามข้อบังคับทางกฎหมาย หรือปัญหาทางเทคนิคที่ตรวจสอบได้ อาจขยายระยะเวลาได้สูงสุด 14 วัน นับจากวันที่ทำธุรกรรม</li>
              </ul>
              <b> 3. วิธีการขอคืนเงิน</b><br/>
              <ul>
                <li>ติดต่อฝ่ายบริการลูกค้าผ่าน [ช่องทางที่กำหนด] พร้อมแจ้งรายละเอียดธุรกรรม, หลักฐานการชำระเงิน, และเหตุผลการขอคืน</li>
                <li>SwiftGamePay อาจขอข้อมูลเพิ่มเติมเพื่อยืนยันตัวตนและตรวจสอบความถูกต้อง</li>
              </ul>
              <b> 4. การหักค่าธรรมเนียม</b><br/>
              <ul>
                <li>การคืนเงินอาจมี การหักค่าธรรมเนียมการดำเนินการ (Processing Fee) ตามอัตราที่ SwiftGamePay กำหนด</li>
                <li>ค่าธรรมเนียมนี้ไม่สามารถขอคืนได้</li>
              </ul>
              <b> 5. วิธีการคืนเงิน</b><br/>
              <ul>
                <li>เงินจะถูกคืนเข้าสู่ กระเป๋าเงิน SwiftGamePay หรือบัญชีต้นทางที่ใช้ทำธุรกรรม</li>
                <li>ระยะเวลาการคืนเงินขึ้นอยู่กับวิธีการชำระเงินเดิมและเงื่อนไขของผู้ให้บริการการชำระเงิน (Payment Gateway / ธนาคาร)</li>
              </ul>
              <b> 6. ข้อยกเว้นการคืนเงิน</b><br/>
              <ul>
                <li>การชำระเงินที่สำเร็จและผู้ใช้ได้รับสินค้าหรือบริการตามปกติแล้ว</li>
                <li>การขอคืนเงินที่เกินระยะเวลาที่กำหนด</li>
                <li>ธุรกรรมที่ฝ่าฝืนข้อกำหนดการใช้งาน หรือมีพฤติกรรมต้องสงสัยว่าทุจริต</li>
              </ul>
              <b> 7. การแก้ไขนโยบาย</b><br/>
              <p>SwiftGamePay ขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไขการคืนเงินโดยไม่ต้องแจ้งล่วงหน้า ทั้งนี้จะใช้เงื่อนไขที่มีผลบังคับในวันที่ผู้ใช้ยื่นคำขอคืนเงิน</p>
          </div>
          </div>
          </div>
        <Footer />
      </div>
    );
  }
}
